<ng-container *ngIf="surveyViewerService.activeSurvey$ | async">
    <div data-testId="openForm" *ngIf="questionFormControl">
        <mat-form-field
                [color]="'primary'" class="w-full" data-testId="open">
                <textarea
                        appNoPaste
                        [errorStateMatcher]="errorMatcher" class="h-24" matInput
                        [formControl]="$any(questionFormControl)"
                        (input)="onInput($event.target.value)"
                (blur)="onBlur($event.target.value.trim())">
                  </textarea>
            <mat-error>
                {{'Champ obligatoire'|transloco}}.
            </mat-error>
        </mat-form-field>
      <ng-container *ngIf="isValidAI| async as isValidAI">
        <div class="warning-message mb-8" *ngIf="!isValidAI.isValid">**** {{isValidAI.explication}}</div>
      </ng-container>
    </div>
<!--  <button (click)="test(errorMatcher)">Test</button>-->
</ng-container>
